import { MeasureCard } from '../../components/viz/MeasureCard';
import { DashboardLayout } from './DashboardLayout';

export function PartnersDashboard() {
  return (
    <DashboardLayout
      title="Training partners"
      intro="aXcelerate partner-domain activity. Cards populate once partner-specific apitoken/wstoken pairs are configured and the cron starts syncing those domains."
    >
      <MeasureCard
        title="Active partners"
        description="Partner domains marked enabled in the aXcelerate registry."
        spec={{ measure: 'partners.active_count' }}
        viz="kpi"
      />
      <MeasureCard
        title="Enrolments — last 90 days"
        description="Per-partner enrolment volume."
        spec={{ measure: 'partners.enrolments_by_domain_last_90d' }}
        viz="bar"
      />
      <MeasureCard
        title="Completions — last 12 months"
        description="Per-partner completed enrolments (status C, outcome 20)."
        spec={{ measure: 'partners.completions_by_domain_last_year' }}
        viz="bar"
      />
    </DashboardLayout>
  );
}
